import React from 'react';
import { Box, Text } from 'pcln-design-system';
import { parseISO } from 'date-fns/parseISO';
import { format } from 'date-fns/format';
export const getDates = (travelStartDate, travelEndDate) => {
  try {
    const startDate = format(parseISO(travelStartDate), 'EEE, MMM d');
    const endDate = format(parseISO(travelEndDate), 'EEE, MMM d');
    return [startDate, endDate];
  } catch (error) {
    return ['', ''];
  }
};
export default ({
  startDateLabel,
  endDateLabel,
  startDate,
  endDate
}) => React.createElement(Box, null, startDate && React.createElement(Text, {
  textStyle: 'paragraph'
}, React.createElement(Text.span, {
  bold: true
}, startDateLabel, ": "), React.createElement(Text.span, null, startDate)), endDate && React.createElement(Text, {
  textStyle: 'paragraph'
}, React.createElement(Text.span, {
  bold: true
}, endDateLabel, ": "), React.createElement(Text.span, null, endDate)));